// products.module.js stays CommonJS because the cron/*.mjs scripts (plain Node) require()/import it directly.
import { productFilters as filters, educationLevels as levels } from './products.module'

export const productFilters = filters
export const educationLevels = levels

export const validProductFilters: string[] = [
    productFilters.educationType,
    productFilters.subject,
    productFilters.brand
]
